<template>
  <section id="fb-events" class="fb-events">
    <iframe style="border: none; overflow: hidden;" width="410" height="512" frameborder="0" scrolling="no"
      src="https://www.facebook.com/plugins/page.php?href=https://www.facebook.com/adventuresofthevalparaiso//&amp;tabs=events&amp;width=410&amp;height=512&amp;small_header=true&amp;adapt_container_width=true&amp;hide_cover=true&amp;show_facepile=true&amp;appId=2047805032153957">
    </iframe>
  </section>
</template>

<script>
export default {
  name: "FbEvents"
};
</script>

<style lang="scss">
.fb-events {

}
</style>



// WEBPACK FOOTER //
// src/components/ValpoFbEvents.vue